<template>
  <div>
    <div class="b-banner-con">
      <v-header></v-header>
      <v-nav></v-nav>
    </div>
    <v-breadcrumb></v-breadcrumb>
    <!-- 主题内容 -->
    <div class="b-center-container">
      <div class="b-container">

        <div class="b-center-main" style="height: 8500px; padding: 60px;">
          <div class="talent-main-left" id="left">
            <div class="title">
              人才队伍
            </div>
            <div class="contentLeft">
              <ul class="leftNavigation">

                <li v-if="this.$route.query.type == 'talent'" class="clickable active"><a href="/talent?type=sskxj"><i class="fa fa-caret-left leftNavIcon" aria-hidden="true"></i>设施科学家</a></li>
                <li v-else class="clickable"><a href="/talent?type=sskxj"><i class="fa fa-caret-left leftNavIcon" aria-hidden="true"></i>设施科学家</a></li>

                <li><a href="javascript:void(0);"><i class="fa fa-caret-right leftNavIcon" aria-hidden="true"></i>管理队伍</a></li>
                <li><a href="javascript:void(0);"><i class="fa fa-caret-right leftNavIcon" aria-hidden="true"></i><span style="margin-left: 15px;">闵行基地</span></a></li>
                <li><a href="/talent?type=sysoffice"><i class="fa fa-caret-right leftNavIcon" aria-hidden="true"></i><span style="margin-left: 30px;">实验室与技术平台</span><span style="margin-left: 30px;">办公室</span></a></li>
                <li><a href="/talent?type=kxyjoffice"><i class="fa fa-caret-right leftNavIcon" aria-hidden="true"></i><span style="margin-left: 30px;">科学研究办公室</span></a></li>
                <li><a href="/talent?type=rlzyoffice"><i class="fa fa-caret-right leftNavIcon" aria-hidden="true"></i><span style="margin-left: 30px;">人力资源办公室、</span><span style="margin-left: 30px;">学生培养办公室</span></a></li>
                <li><a href="/talent?type=zhoffice"><i class="fa fa-caret-right leftNavIcon" aria-hidden="true"></i><span style="margin-left: 30px;">综合办公室</span></a></li>
                <li><a href="/talent?type=dwoffice"><i class="fa fa-caret-right leftNavIcon" aria-hidden="true"></i><span style="margin-left: 30px;">对外合作办公室</span></a></li>
              </ul>
            </div>
          </div>

          <div class="talent-main-right" id="right">
          <p style="text-align: left; margin-bottom: 40px; "><span style="font-size: 22px; border-bottom: solid 3px rgb(12, 92, 200);">{{ typeText }}</span></p>

            <div class="right-nr">
                  <div class="teacher-detail-img" style="height: 250px">
                      <img :src="data.IP_URL + '/ueditor/images/zoomin_'+data.picture">
                  </div>
                  <div class="teacher-detail-txt" style="text-align: left; margin-bottom: 30px; height: 240px">
                      {{ data.title }}
                    <p v-html="richText"></p>
                  </div>
                  <p v-html="dynamicText"></p>
            </div>
          </div>

        </div>
      </div>
    </div>
    <v-contact></v-contact>

  </div>
</template>
<script>
/* eslint-disable */
import Header from "@/components/header/";
import Nav from "@/components/nav/";
import Copy from "@/components/copy/"
import Breadcrumb from "@/components/breadcrumb/"
import Footer from "@/components/footer/"
import Contact from "@/components/contact/";
import $ from "jquery";
export default {
  methods: {
    btnMenu() {
      // 点击时隐藏
      this.isShow = !this.isShow
    },
    btnMenu2() {
      // 点击时隐藏
      this.isShow2 = !this.isShow2
    }
  },

  data () {
    return {
      richText: '',
      dynamicText: '',
      data : new Object(),
      isShow: false,
      isShow2: false,
    //   pageSize: 20,
    //   newsList: [],
    //   count:0,
    //   sliceNewsList: [],
    //   categoryList: [],
    };
  },
  mounted () {
    var id = this.$route.query.id;
    var type = this.$route.query.type;
    var baseUrl =  Header.IP_URL + '/' +  'talent/detail?talentId='+id;
    // 新闻列表
    //为了在内部函数能使用外部函数的this对象，要给它赋值了一个名叫self的变量。
    var self = this;

    $.ajax({
      url: baseUrl,
      type: 'get',
      // data: {},
      dataType: 'json'
    }).then(function (res) {
      console.log(res);
      self.data = res.data;
      self.data.IP_URL = Header.IP_URL;

      if(self.data.position !=null && self.data.position !='')
        self.richText += '<p style="text-align: left;"><b style="font-weight: bold">职位：</b>'+ self.data.position + '</p>' +
                    '<p></p>';
      if(self.data.email !=null && self.data.email !='')
        self.richText += '<p style="text-align: left;"><b style="font-weight: bold">电子邮箱：</b>'+ self.data.email + '</p>' +
                    '<p></p>';
      if(self.data.address !=null && self.data.address !='')
        self.richText += '<p style="text-align: left;"><b style="font-weight: bold">办公地点：</b>'+ self.data.address + '</p>' +
          '<p></p>';
      if(self.data.phone !=null && self.data.phone !='')
        self.richText += '<p style="text-align: left;"><b style="font-weight: bold">电话：</b>'+ self.data.phone + '</p>' +
          '<p></p>';
      if(self.data.website !=null && self.data.website !='')
        self.richText += '<p style="text-align: left;"><b style="font-weight: bold">个人网页/课题组主页地址：</b>'+ self.data.website + '</p>' +
          '<p></p>';

      //console.log(self.data.content)
      var abbrs = self.data.abbrs;
      var contents = self.data.content;

      for(var i=0; i<abbrs.length;  i++) {
          self.dynamicText += '<p style="text-align: left; font-size: 18px; border-bottom: 1px solid rgb(12, 92, 200); margin-bottom: 20px">' + abbrs[i] + ':</p>';
          var temp = contents[i].split(/[\n]/g);
          for(var j =0;j<temp.length; j++){
            if(temp[j] == ""){
              temp.splice(j, 1);
              //删除数组索引位置应保持不变
              j--;
            }
          }
          self.dynamicText += '<ul style="margin-bottom: 30px">';
          for(var j =0;j<temp.length;j++){
            self.dynamicText += '<li style="text-align:justify; line-height: 30px; margin-bottom: 20px;">' + temp[j] + '</li>';   //▶
          }
          self.dynamicText += '</ul>';
      }
      // console.log(self.dynamicText)

      if(self.data.type == 'sskxj')
        self.typeText = '设施科学家';
      else if(self.data.type == 'sskxjzl')
        self.typeText = '设施科学家助理';
      else if(self.data.type == 'jszxzr')
        self.typeText = '技术中心主任';
    }).fail(function () {
      console.log('失败');
    });
  },
  components: {
    "v-header": Header,
    "v-nav": Nav,
    "v-copy": Copy,
    "v-breadcrumb": Breadcrumb,
    "v-footer": Footer,
    "v-contact": Contact,
  }
};
</script>
<style lang="scss">
.b-banner-con{
  //padding: 22px 0;
  background: url(../../../assets/img/banner_bg.png) no-repeat!important;
  background-size: cover!important;
  .b-header{
    margin-bottom: 0px;
  }
}

/******左侧导航******/

.talent-main-left {
  float: left;
  width: 15%;
  height: 1800px;
  margin-right: 115px;

  .title {
    width: 230px;
    margin-bottom: 0px;
    position: relative;
    padding: 10px 15px 11px;
    background: #0c5cc8;
    font-size: 22px;
    font-weight: 500;
    color:#ffffff;
    text-transform:uppercase;
  }

  .contentLeft {
    width: 230px;
    float: left;
    margin-right: 35px;
    top: 0;
    left: 0;
    background-color: #f2f7ff;
  }
  .leftNavigation {
    margin: 0rem 0;
  }
  .leftNavigation li {
    border-bottom: solid 1px #c6dbf5;
    border-right: solid 1px #c6dbf5;
    text-align: left;
  }
  .leftNavigation, .leftNavigation li ul {
    list-style: none;
    padding: 0;
  }
  .leftNavigation li a {
    font-size: 16px;
    display: block;
    padding: 10px 30px 10px 20px;
    color: #1f1f1f;
    /*border-bottom: solid 1px #1e76b8;*/
    text-overflow: ellipsis;
    overflow: hidden;
    position: relative;
    -webkit-transition: color 0.2s ease;
    transition: color 0.2s ease;
    font-weight:400;
    border-left: #c6dbf5 solid 5px;
    border-right: #c6dbf5 solid 5px;
  }
  .leftNavigation li a, .leftNavigation li a .leftNavIcon {
    line-height: 160%;
  }
  .leftNavigation li a .leftNavIcon {
    position: absolute;
    top: 0;
    left: -1px;
    /*width: 3rem;*/
    padding: 6px 0;
    text-align: center;
    font-weight:100;color: #f2f7ff;font-size: 20px;
  }
  .leftNavigation li.active a .leftNavIcon {color: #7396c3;}
  .leftNavigation li a .leftNavIcon1 {
    position: absolute;
    top: 0;
    left: 0;
    width: 4rem;
    padding: 0.8rem 0;
    text-align: center;
  }
  .leftNavigation li a:hover {
    color: #142e8f; text-decoration:none; background:#d6e7fd;
    border-left: #7396c3 solid 5px;
    border-right: #7396c3 solid 5px;
  }
  .leftNavigation li a:hover .leftNavIcon {color: #7396c3;}
  .leftNavigation li ul {
    /*display: none;*/
    margin: 0;border-top: solid 1px #c6dbf5;border-left: #c6dbf5 solid 5px;padding: 8px 0;
  }
  .leftNavigation li ul li { border-bottom: solid 0px #1e76b8;}
  .leftNavigation li ul li a {
    border: 0px; font-size:13px; color:#383838; background:url(../../../assets/img/csu_ico_17.gif) no-repeat 30px 10px;padding: 5px 15px 5px 48px;border-left: 0;
  }
  .leftNavigation li ul li a:hover {
    background:url(../../../assets/img/csu_ico_17.gif) no-repeat 30px 10px;color:#142e8f;text-decoration:none;border: 0;
  }
  /*#

   li ul li:last-child a {
    border-bottom: none;
  }*/
  .leftNavigation li ul li.active a {
    color: #8bebff; text-decoration:none;
  }
  .leftNavigation li.active > a {
    color: #142e8f; text-decoration:none;
    border-left: #7396c3 solid 5px;
    border-right: #7396c3 solid 5px;
  }
  .leftNavigation li.active ul {
    display: block;border-top: solid 1px #1e76b8;
  }
  .leftNavigation > li.active {
    background-color: #d6e7fd;
  }
  .leftNavigation li ul li .level4 {border-top: solid 1px #1e76b8;}
  .leftNavigation li ul li .level4 li a {
    border-bottom: solid 0px #D0E9F3; font-size:14px; color:#e2f5fa; padding-left:42px;background: transparent;border-left: #2473c0 solid 5px;
  }
  .leftNavigation li ul li .level4 li a:hover {color: #8bebff;}
  .leftNavigation li ul li .level4 li {border-bottom: solid 1px #1e76b8;}
  .leftNavigation li ul li .level4 li:last-child {border-bottom: solid 0px #D0E9F3;}

}

/******右侧样式******/
.talent-main-right {
  float: left;
  width: 72%;
  //position: relative;
  margin-top: 30px;
  min-height: 1800px;
}
/*左侧导航：*/

/*左侧导航：*/

.side-nav-panel {
  // background: #f1f4f7 url(../images/leftbg.jpg) no-repeat left bottom;
  background: #f1f4f7;
  padding-bottom: 50px;
  padding-top: 30px;
}

.nav-panel-title {
  font-size: 22px;
  color: #fff;
  min-height: 72px;
  //background: #00274b url(../images/ntbg.png) no-repeat right center;
  background: rgb(12, 92, 200);
  padding-left: 35px;
  padding-top: 20px;
  text-align: left;
}

.nav-panel-title i {
  width: 107px;
  height: 3px;
  background: #fff;
  display: block;
  margin-top: 14px;
}




.slide-nav-ul {
  margin-left: 5px;
}

.slide-nav-ul li:first-child {
  /* border-top: none; */
}

.slide-nav-ul li {
  //position: relative;
  /*border-bottom: 1px solid #bbb;*/
}

.slide-nav-ul li.js-item {
  margin-bottom: 0px;
}

.slide-nav-ul li a {
  color: #000;
  display: block;
  position: relative;
  font-size: 18px;
  padding: 20px 0px 20px 0px;
  line-height: 22px;
  text-decoration: none;
}


/* 左侧二级选中 .parent */
.slide-nav-ul li a:hover, .slide-nav-ul li a.active, .slide-nav-ul li a.selected, .slide-nav-ul li a.parent {
  font-weight: bold;
  color: #00446a;
}


/*内页三级导航*/
.slide-nav-item-ul1 {
  display: none;
}

.slide-nav-item-ul {

}

.slide-nav-item-ul li {
  line-height: 26px;
  border: none;
  padding: 0px;
  display: block;
}

.slide-nav-item-ul li:hover {
  border-bottom: none;
}

.slide-nav-item-ul li a {
  display: block;
  color: #000;
  font-weight: normal;
  font-size: 18px;
  padding: 20px 0px 20px 0px;
  line-height: 22px;
  border: none;
  background: none;
}


/* 三级选中 .selected */
.slide-nav-ul li .slide-nav-item-ul li a:hover, .slide-nav-ul li .slide-nav-item-ul a.active, .slide-nav-ul li .slide-nav-item-ul a.selected {
  font-weight: normal;
  color: #00446a;
}


/*右侧内容*/
.right-nr {
  font-size: 16px;
  color: #000;
  position: relative;
  margin-top: 30px;
  padding-bottom: 50px;
}

/* 师资列表 */
.teacher-ul {
}

.teacher-ul li {
  padding: 15px;
  margin-bottom: 30px;
  background: #f5f5f5;
  width: 48%;
  float: left;
  margin-right: 4%;
}

.teacher-ul li:nth-child(even) {
  margin-right: 0%;
}

.teacher-detail-img {
  width: 25%;
  float: left;
}

/*.teacher-detail-txt {*/
/*  width: 75%;*/
/*  padding-left: 5%;*/
/*  float: left;*/
/*}*/

.teacher-detail-txt {
  margin-left: 240px;
  font-size: 22px;
  color: rgb(12, 92, 200);
  display: block;
  margin-bottom: 50px;
}

.teacher-detail-txt p {
  margin-top: 10px;
  font-size: 16px;
  color: #000;
  line-height: 28px;
}

/* end */

</style>



// WEBPACK FOOTER //
// src/pages/talent/detail/index.vue